declare module '@mui/material/styles' {
	interface Palette {
		navbar: {
			primary: {
				main: string;
				active: string;
			};
			secondary: {
				main: string;
				active: string;
			};
		},
		border: {
			primary: string
		};
	}
	interface PaletteOptions {
		navbar?: {
			primary?: {
				main?: string;
				active?: string;
			};
			secondary?: {
				main?: string;
				active?: string;
			};
		};
	}
}

export const palette = {
	background: {
		default: '#949EC20A',
		paper: '#EAECF3',
	},
	primary: {
		main: '#023671',
	},
	secondary: {
		main: '#949EC2',
		light: '#BEC4DB',
	},
	navbar: {
		primary: {
			main: '#023671',
			active: '#023671',
		},
		secondary: {
			main: '#fff',
			active: '#DC2C35',
		},
	},
	text: {
		primary: '#161616',
		secondary: '#161616',
		disabled: '#84858a',
		dark:'#00265A',
	},
	action: {
		disabled: '#f1f1f3'
	},
	border: {
		primary: '#EAF0F1',
	}
};
